import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import baseURL from "../../../../Url/NodeBaseURL";
import { Col, Row, Button, Dropdown, DropdownButton } from "react-bootstrap";
import { FaTrash, FaCamera, FaUpload } from "react-icons/fa";

const VendorAssignments = () => {
  const navigate = useNavigate();
  const { id, productid } = useParams();
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const imageInputRef = useRef(null);

  const videoInputRef = useRef(null);
  const [productInput, setProductInput] = useState({
    actual_gross_weight: "",
    actual_wastage_weight: "",
    actual_price: "",
    making_charges: "",
    total_price: "",
    weight_bw: "",
    actual_total_weight: "",
    images: [],
  });
  const headTheme = { "--bs-table-bg": "#a36e29", "--bs-table-color": "#fff" };

  const [otp, setOtp] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [otpTimer, setOtpTimer] = useState(30);

  const sendOtp = async () => {
    try {
      const response = await axios.post(`${baseURL}/auth/send-otp`, {
        vendorId: id,
      });
      if (response.data.success || response.data.otp) {
        setOtpSent(true);
        setOtpTimer(30);
      } else {
        setOtpError("Failed to send OTP.");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      setOtpError("Failed to send OTP.");
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const response = await axios.post(`${baseURL}/auth/verify-otp`, {
        vendorId: id,
        otp,
      });
      if (
        response.data.success ||
        response.data.message === "OTP verified successfully"
      ) {
        setOtpVerified(true);
      } else {
        setOtpError("Invalid OTP");
      }
    } catch (error) {
      console.error("OTP verification failed", error);
      setOtpError("Verification failed.");
    }
  };

  // useEffect(() => {
  //   sendOtp();
  // }, [id]);
  const handleImageChange = async (e) => {
    const files = Array.from(e.target.files);

    const base64Files = await Promise.all(
      files.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve({ src: reader.result, type: file.type }); // include MIME type
          };
          reader.onerror = () => reject("Error reading file");
          reader.readAsDataURL(file);
        });
      })
    );

    setProductInput((prev) => ({
      ...prev,
      images: [
        ...(Array.isArray(prev.images) ? prev.images : []),
        ...base64Files,
      ],
    }));

    setShowOptions(false);
  };

  const clearImage = (index) => {
    setProductInput((prev) => ({
      ...prev,
      images: Array.isArray(prev.images)
        ? prev.images.filter((_, i) => i !== index)
        : [],
    }));
  };

  useEffect(() => {
    let timer;
    if (otpSent && otpTimer > 0 && !otpVerified) {
      timer = setTimeout(() => setOtpTimer((prev) => prev - 1), 1000);
    } else if (otpTimer === 0 && !otpVerified) {
      setOtpError("OTP expired. Please refresh to request a new one.");
    }
    return () => clearTimeout(timer);
  }, [otpTimer, otpSent, otpVerified]);

  const fetchAssignments = async () => {
    try {
      const response = await axios.get(`${baseURL}/vendor/${id}/assignments`);
      const assignments = response.data.assignments || [];
      setData(assignments);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching vendor assignments:", error);
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   const product = data.find((item) => String(item.id) === productid);
  //   if (product) {
  //     const rate = product.rate || 0; // fallback to 0 if not available
  //     const gross = parseFloat(productInput.actual_gross_weight) || 0;
  //     const wastage = parseFloat(productInput.actual_wastage_weight) || 0;

  //     setProductInput((prev) => ({
  //       ...prev,
  //       actual_price: (gross + wastage) * rate,
  //     }));
  //   }
  // }, [productInput.actual_gross_weight, productInput.actual_wastage_weight]);

  useEffect(() => {
    if (otpVerified) {
      fetchAssignments();
    }
  }, [id, otpVerified]);
  useEffect(() => {
    if (!data.length || !productid) return;

    const product = data.find((item) => String(item.id) === productid);
    if (!product) return;

    const grossWeight = parseFloat(productInput.actual_gross_weight) || 0;
    const wastagePercent = parseFloat(productInput.actual_wastage_weight) || 0; 
    const stonesWeight = parseFloat(product.stone_weight) || 0;
    const rate = parseFloat(product.rate) || 0;
    const stonePrice = parseFloat(product.stone_price) || 0;

    const weightBW = grossWeight - stonesWeight;

    const wastageWeight = (grossWeight* wastagePercent) / 100;
    const totalWeight = weightBW + wastageWeight;
    const totalPrice = totalWeight * rate;

    const hmType = product.assigned_hm_type;
    const hmCharges = parseFloat(product.assigned_hm_charges) || 0;
    let makingCharges = 0;

    if (hmType === "MC / Gram") {
      makingCharges = hmCharges * totalWeight;
    } else if (hmType === "MC %") {
      makingCharges = (hmCharges * totalPrice) / 100;
    } else if (hmType === "MC / Piece") {
      makingCharges = hmCharges;
    }

    const actualPrice = totalPrice + stonePrice + makingCharges;

    setProductInput((prev) => ({
      ...prev,
      weight_bw: weightBW.toFixed(3),
      actual_total_weight: totalWeight.toFixed(3),
      total_price: totalPrice.toFixed(2),
      making_charges: makingCharges.toFixed(2),
      actual_price: actualPrice.toFixed(2),
    }));
  }, [
    productInput.actual_gross_weight,
    productInput.actual_wastage_weight,
    data,
    productid,
  ]);

  // useEffect(() => {
  //   if (!data.length || !productid) return;

  //   const product = data.find((item) => String(item.id) === productid);
  //   if (!product) return;

  //   const hmType = product.assigned_hm_type;
  //   const hmCharges = parseFloat(product.assigned_hm_charges);
  //   const rate = parseFloat(product.rate);

  //   if (hmType === "MC / Gram" && rate && hmCharges) {
  //     const calculated = (hmCharges * rate).toFixed(2);
  //     setProductInput((prev) => ({
  //       ...prev,
  //       making_charges: calculated,
  //     }));
  //   } else if (hmType === "MC %" && rate && hmCharges) {
  //     const calculated = ((hmCharges * rate) / 100).toFixed(2);

  //     setProductInput((prev) => ({
  //       ...prev,
  //       making_charges: calculated,
  //     }));
  //   } else if (hmType === "MC / Piece" && hmCharges) {
  //     setProductInput((prev) => ({
  //       ...prev,
  //       making_charges: hmCharges,
  //     }));
  //   }
  // }, [data, productid]);
  // useEffect(() => {
  //   if (!data.length || !productid) return;

  //   const product = data.find((item) => String(item.id) === productid);
  //   if (!product) return;
  //   const grossWeight = parseFloat(productInput.actual_gross_weight) || 0;
  //   const stonesWeight = parseFloat(product.stone_weight) || 0;
  //   const weightBW = grossWeight - stonesWeight;

  //   setProductInput((prev) => ({
  //     ...prev,
  //     weight_bw: weightBW.toFixed(3),
  //   }));
  // }, [productInput.actual_gross_weight, data, productid]);

  // useEffect(() => {
  //   const product = data.find((item) => String(item.id) === productid);
  //   if (!product) return;

  //   const rate = parseFloat(product?.rate) || 0;
  //   const weightBW = parseFloat(productInput.weight_bw) || 0;
  //   const wastageWeight = parseFloat(productInput.actual_wastage_weight) || 0;
  //   const stonePrice = parseFloat(product.stone_price) || 0;
  //   const makingCharges = parseFloat(productInput.making_charges) || 0;

  //   const totalWeight = weightBW + wastageWeight;
  //   const totalPrice = totalWeight * rate;
  //   const actualPrice = totalPrice + stonePrice + makingCharges;

  //   setProductInput((prev) => ({
  //     ...prev,
  //     actual_total_weight: totalWeight.toFixed(3),
  //     total_price: totalPrice.toFixed(2),
  //     actual_price: actualPrice.toFixed(2),
  //   }));
  // }, [
  //   productInput.weight_bw,
  //   productInput.actual_wastage_weight,
  //   productInput.making_charges,
  //   data,
  //   productid,
  // ]);

  useEffect(() => {
    if (otpVerified) {
      fetchAssignments();
    }
  }, [id, otpVerified]);

  useEffect(() => {
    if (data.length > 0 && productid) {
      const product = data.find((item) => String(item.id) === productid);
      if (product) {
        console.log();
        let parsedImages = [];
        try {
          parsedImages = JSON.parse(product.submission_images);
        } catch (e) {}
        setHasSubmitted(
          !!product.submission_actual_price ||
            !!product.submission_actual_gross_weight ||
            !!product.submission_actual_wastage_weight ||
            (Array.isArray(parsedImages) && parsedImages.length > 0)
        );

        setProductInput((prev) => ({
          ...prev,
          actual_wastage_weight: product.submission_actual_wastage_weight || product.assigned_wastage_weight || "",
          images: (() => {
            try {
              let raw = product.submission_images;

              if (typeof raw === "string") {
                // Handle double-string case
                const once = JSON.parse(raw); // gives you still a string
                return Array.isArray(once) ? once : JSON.parse(once);
              }

              if (Array.isArray(raw)) return raw;
            } catch (err) {
              console.error("Image parsing failed:", err);
            }
            return [];
          })(),
        }));
      }
    }
  }, [data, productid]);

  const handleSubmit = async () => {
    const payload = {
      actualGrossWeight: productInput.actual_gross_weight,
      actualWastageWeight: productInput.actual_wastage_weight,
      actualPrice: productInput.actual_price,
      submissionImages: productInput.images,
      status: "in review",
    };
    setLoading(true);
    try {
      console.log("has submitted", hasSubmitted);
      if (hasSubmitted) {
        await axios.patch(
          `${baseURL}/vendor/${id}/submissions/${productid}`,
          payload
        );
        alert("Submission updated!");
      } else {
        console.log("submission value", payload);
        await axios.post(
          `${baseURL}/vendor/${id}/assignments/${productid}/submit`,
          payload
        );
        alert("Submitted successfully!");
      }

      await fetchAssignments();
      navigate(`/vendor/${id}/assignments`);
    } catch (error) {
      console.error("Error submitting/editing:", error);
      alert("Failed to submit.");
    } finally {
      setLoading(false); // End loading regardless of outcome
    }
  };

  if (!otpVerified) {
    return (
      <div className="main-container text-center">
        <div className="mt-5">
          <h5>OTP Verification</h5>

          {!otpSent ? (
            <Button
              onClick={sendOtp}
              style={{ backgroundColor: "#a36e29", borderColor: "#a36e29" }}
            >
              Send OTP
            </Button>
          ) : (
            <>
              <input
                type="text"
                className="form-control w-25 mx-auto my-3"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
              {otpError && <p className="text-danger">{otpError}</p>}
              {otpTimer > 0 && <p>OTP expires in {otpTimer}s</p>}
              <Button
                onClick={handleVerifyOtp}
                style={{ backgroundColor: "#a36e29", borderColor: "#a36e29" }}
              >
                Verify OTP
              </Button>
            </>
          )}
        </div>
      </div>
    );
  }

  if (productid) {
    const product = data.find((item) => String(item.id) === productid);
    if (!product) return <p>Product not found.</p>;

    return (
      <div className="main-container mt-3">
        <div className="payments-table-container">
          <Row className="mb-3">
            <Col className="d-flex justify-content-between align-items-center">
              <h4>Assignment Details</h4>
              <Button
                className="create_but"
                onClick={() => navigate(-1)}
                style={{ backgroundColor: "#a36e29", borderColor: "#a36e29" }}
                size="sm"
              >
                ← Back
              </Button>
            </Col>
          </Row>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
              <div style={{ overflowX: "auto" }}>
                <table className="table table-bordered border-dark-subtle">
                  <tbody>
                    <tr>
                      <th>Bar Code</th>
                      <td>{product.code}</td>
                      <th>Product Name</th>
                      <td>{product.product_name}</td>
                      <th>Metal Type</th>
                      <td>{product.metal_type}</td>
                      <th>Purity</th>
                      <td>{product.purity}</td>
                    </tr>
                    <tr>
                      <th>Gross Wt</th>
                      <td>{product.gross_weight}</td>
                      <th>Stone Wt</th>
                      <td>{product.stone_weight}</td>
                      <th>W.Wt</th>
                      <td>{product.wastage_weight}</td>
                      <th>Total Wt</th>
                      <td>{product.total_weight_av}</td>
                    </tr>
                    <tr>
                      <th>Size</th>
                      <td colSpan="7">{product.size}</td>
                    </tr>
                    <tr>
                      <th colSpan="9" className="text-center">
                        Assigned Metals
                      </th>
                    </tr>
                    <tr>
                      <td colSpan="9">
                        {(() => {
                          let metals = [];

                          try {
                            let parsed = JSON.parse(
                              product.assigned_metals || "[]"
                            );
                            metals =
                              typeof parsed === "string"
                                ? JSON.parse(parsed)
                                : parsed;
                          } catch (err) {
                            console.error("Invalid assigned_metals JSON:", err);
                          }

                          if (!Array.isArray(metals) || metals.length === 0) {
                            return <div>No assigned metals</div>;
                          }

                          return (
                            <table className="table table-bordered border-dark-subtle mt-2">
                              <thead style={headTheme}>
                                <tr>
                                  <th>Metal Type</th>
                                  <th>Purity</th>
                                  <th>Weight</th>
                                  <th>MC Type</th>
                                  <th>MC</th>
                                  <th>Total Cost</th>
                                  <th>Additional Description</th>
                                  <th>Additional Images/Videos</th>
                                </tr>
                              </thead>
                              <tbody>
                                {metals.map((m, idx) => (
                                  <tr key={idx}>
                                    <td>{m.metal_type}</td>
                                    <td>
                                      {m.metal_purity === "Manual"
                                        ? `Manual - ${m.custom_purity || ""}%`
                                        : m.metal_purity}
                                    </td>
                                    <td>{m.metal_weight}</td>
                                    <td>{product.assigned_hm_type}</td>
                                    <td>{product.assigned_hm_charges}</td>
                                    <td>{m.rate}</td>
                                    <td>{m.additional_description}</td>
                                    <td>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                          gap: "8px",
                                          marginTop: "4px",
                                        }}
                                      >
                                        {(() => {
                                          let mediaItems = [];
                                          try {
                                            mediaItems = Array.isArray(
                                              m.additional_images
                                            )
                                              ? m.additional_images
                                              : JSON.parse(
                                                  m.additional_images || "[]"
                                                );
                                          } catch (err) {
                                            console.error(
                                              "Invalid image JSON:",
                                              err
                                            );
                                          }

                                          return mediaItems.map(
                                            (item, index) => {
                                              const src =
                                                typeof item === "string"
                                                  ? item
                                                  : item.src;
                                              const type = item?.type || "";

                                              if (type.startsWith("video/")) {
                                                return (
                                                  <video
                                                    key={index}
                                                    src={src}
                                                    width="100"
                                                    height="80"
                                                    controls
                                                    style={{
                                                      objectFit: "cover",
                                                      border: "1px solid #ccc",
                                                      borderRadius: "4px",
                                                    }}
                                                  />
                                                );
                                              }

                                              return (
                                                <img
                                                  key={index}
                                                  src={src}
                                                  alt={`media-${index}`}
                                                  width="100"
                                                  height="80"
                                                  style={{
                                                    objectFit: "cover",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                  }}
                                                />
                                              );
                                            }
                                          );
                                        })()}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          );
                        })()}
                      </td>
                    </tr>

                    {/* Samples Section */}
                    <tr>
                      <th colSpan="9" className="text-center">
                        Samples
                      </th>
                    </tr>
                    <tr>
                      <td colSpan="9">
                        {(() => {
                          let samples = [];

                          try {
                            let parsed = product.assigned_samples;
                            if (typeof parsed === "string")
                              parsed = JSON.parse(parsed);
                            if (typeof parsed === "string")
                              parsed = JSON.parse(parsed);
                            samples = Array.isArray(parsed) ? parsed : [];
                          } catch (err) {
                            console.error(
                              "Invalid assigned_samples JSON:",
                              err
                            );
                          }

                          if (!Array.isArray(samples) || samples.length === 0) {
                            return <div>No samples</div>;
                          }

                          return (
                            <table className="table table-bordered border-dark-subtle mt-2">
                              <thead style={headTheme}>
                                <tr>
                                  <th>Metal Type</th>
                                  <th>Purity</th>
                                  <th>Weight</th>
                                  <th>Description</th>
                                  <th>Photo</th>
                                </tr>
                              </thead>
                              <tbody>
                                {samples.map((sample, index) => (
                                  <tr key={index}>
                                    <td>{sample.sample_metaltype || "—"}</td>
                                    <td>
                                      {sample.sample_purity === "Manual"
                                        ? `Manual - ${
                                            sample.sample_custom_purity || ""
                                          }%`
                                        : sample.sample_purity}
                                    </td>
                                    <td>{sample.sample_wt || "—"}</td>
                                    <td>{sample.sample_des || "—"}</td>
                                    <td>
                                      {Array.isArray(sample.sample_photo) &&
                                      sample.sample_photo.length > 0
                                        ? sample.sample_photo.map((img, i) => (
                                            <img
                                              key={i}
                                              src={img}
                                              alt={`sample-${index}-${i}`}
                                              width="100"
                                              height="80"
                                              style={{
                                                objectFit: "cover",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                marginRight: "5px",
                                              }}
                                            />
                                          ))
                                        : "No Image"}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          );
                        })()}
                      </td>
                    </tr>
                    <tr>
                      <th>Payment Mode</th>
                      <td colSpan="3">{product.assigned_payment_mode}</td>
                      <th>Advance Amount </th>
                      <td colSpan="3">{product.assigned_advance_amt}</td>
                    </tr>
                    <tr>
                      <th>Actual Gross Weight</th>
                      <td colSpan="3">
                        <input
                          type="text"
                          className="form-control"
                          value={productInput.actual_gross_weight || ""}
                          onChange={(e) =>
                            setProductInput({
                              ...productInput,
                              actual_gross_weight: e.target.value,
                            })
                          }
                        />
                      </td>
                      <th>Actual Wastage Percentage</th>
                      <td colSpan="3">
                        <input
                          type="text"
                          className="form-control"
                          value={productInput.actual_wastage_weight || ""}
                          onChange={(e) =>
                            setProductInput({
                              ...productInput,
                              actual_wastage_weight: e.target.value,
                            })
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Actual Price</th>
                      <td colSpan="7">
                        <input
                          type="text"
                          className="form-control"
                          value={productInput.actual_price || ""}
                          readOnly
                        />
                      </td>
                    </tr>

                    <tr>
                      <th>Additional Media</th>
                      <td colSpan="7">
                        <div className="d-flex align-items-start gap-3 mt-1">
                          {/* Upload Dropdown */}
                          <div>
                            <DropdownButton
                              id="dropdown-basic-button"
                              title="Additional Images / Videos"
                              variant="primary"
                              size="sm"
                              onClick={() => setShowOptions(!showOptions)}
                            >
                              {showOptions && (
                                <>
                                  <Dropdown.Item
                                    onClick={() => {
                                      if (imageInputRef.current)
                                        imageInputRef.current.click();
                                    }}
                                  >
                                    <FaUpload /> Choose Image
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      if (videoInputRef.current)
                                        videoInputRef.current.click();
                                    }}
                                  >
                                    <FaUpload /> Choose Video
                                  </Dropdown.Item>
                                </>
                              )}
                            </DropdownButton>

                            {/* Hidden Inputs */}
                            <input
                              type="file"
                              accept="image/*"
                              multiple
                              ref={imageInputRef}
                              style={{ display: "none" }}
                              onChange={handleImageChange}
                            />
                            <input
                              type="file"
                              accept="video/*"
                              multiple
                              ref={videoInputRef}
                              style={{ display: "none" }}
                              onChange={handleImageChange}
                            />
                          </div>

                          {Array.isArray(productInput.images) &&
                            productInput.images.length > 0 && (
                              <div className="d-flex flex-wrap gap-2">
                                {productInput.images.map((preview, index) => {
                                  const isVideo =
                                    preview.type?.startsWith("video");

                                  return (
                                    <div
                                      key={index}
                                      style={{
                                        position: "relative",
                                        display: "inline-block",
                                      }}
                                    >
                                      {isVideo ? (
                                        <video
                                          src={preview.src}
                                          width="100"
                                          height="100"
                                          controls
                                          style={{
                                            borderRadius: "8px",
                                            objectFit: "cover",
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={preview.src}
                                          alt={`Preview ${index}`}
                                          style={{
                                            width: "100px",
                                            height: "100px",
                                            borderRadius: "8px",
                                            objectFit: "cover",
                                          }}
                                        />
                                      )}
                                      <button
                                        type="button"
                                        onClick={() => clearImage(index)}
                                        style={{
                                          position: "absolute",
                                          top: "5px",
                                          right: "5px",
                                          background: "transparent",
                                          border: "none",
                                          color: "red",
                                          fontSize: "16px",
                                          cursor: "pointer",
                                          zIndex: 10,
                                        }}
                                      >
                                        <FaTrash />
                                      </button>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div className="text-center mt-4">
                  <button
                    className="btn btn-primary"
                    style={{
                      backgroundColor: "#a36e29",
                      borderColor: "#a36e29",
                      padding: "8px 24px",
                      fontWeight: "bold",
                    }}
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="main-container">
      <div className="payments-table-container">
        <Row className="mb-3">
          <Col className="d-flex justify-content-between align-items-center">
            <h3>Assignments for vendor</h3>
            <Button
              className="create_but"
              onClick={() => navigate("/orderstable")}
              style={{ backgroundColor: "#a36e29", borderColor: "#a36e29" }}
            >
              ← Back
            </Button>
          </Col>
        </Row>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <div style={{ overflowX: "auto" }}>
              <table className="table table-bordered">
                <thead className="thead-light">
                  <tr>
                    <th>Bar Code</th>
                    <th>Product Name</th>
                    <th>Metal Type</th>
                    <th>Purity</th>
                    <th>Gross Wt</th>
                    <th>Stone Wt</th>
                    <th>W.Wt</th>
                    <th>Total Wt</th>
                    <th>Size</th>
                    <th>Total Price</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((product, index) => (
                    <tr key={index}>
                      <td>{product.code}</td>
                      <td>{product.product_name}</td>
                      <td>{product.metal_type}</td>
                      <td>{product.purity}</td>
                      <td>{product.gross_weight}</td>
                      <td>{product.stone_weight}</td>
                      <td>{product.wastage_weight}</td>
                      <td>{product.total_weight_av}</td>
                      <td>{product.size}</td>
                      <td>{product.total_price}</td>
                      <td>
                        {product.submission_status !== "selected" && (
                          <Button
                            size="sm"
                            variant="outline-primary"
                            style={{ padding: "2px 6px", fontSize: "12px" }}
                            onClick={() => {
                              navigate(
                                `/vendor/${id}/assignments/${product.id}`
                              );
                            }}
                          >
                            View
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VendorAssignments;
